<template>
  <div>
    <el-form ref="formRef" :model="imgForm" label-width="88px">
      <el-form-item label="平台：">
        <el-select v-model="platform" placeholder="Select" style="width: 25em">
          <el-option v-for="item in platformArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道：">
        <el-input v-model="channel" :disabled="platform == 1 || platform == 4" placeholder="请输入渠道" style="width:25em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { createQrCodeImg } from "@/api/url";

export default {
  name: "LetterUpdateDialog",
  props: {
    value: Object
  },
  data() {
    return {
      imgForm: this.value.imgForm,
      idx: this.value.ids,
      loading: false,

      //平台
      platformArray: [
        {label:'Android', value: 1},
        {label:'鸿蒙', value: 4},
        {label:'IOS', value: 2}
      ],
      platform: 1,
      channel: '',

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(this.channel == '' && this.platform == 2) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '渠道不能为空',
          type: 'warning'
        })
        return false;
      }
      this.loading = true
      let param = {};
      // param['id'] = this.imgForm.id?this.imgForm.id:0;
      param['platform'] = this.platform;
      param['appChannel'] = this.channel;
      postFormData(createQrCodeImg, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
